import client from './client';

export interface NewsItem {
  id: number;
  title_kk: string;
  title_ru: string;
  body_kk?: string;
  body_ru?: string;
  image_url?: string;
  category?: string;
  is_emergency: boolean;
  target_district?: string;
  published_at: string;
  created_at: string;
}

export interface NewsCreate {
  title_kk: string;
  title_ru: string;
  body_kk?: string;
  body_ru?: string;
  image_url?: string;
  category?: string;
  is_emergency?: boolean;
  target_district?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export const newsApi = {
  list: (params?: { page?: number; size?: number; category?: string; search?: string }) =>
    client.get<PaginatedResponse<NewsItem>>('/api/admin/news', { params }),

  get: (id: number) =>
    client.get<NewsItem>(`/api/admin/news/${id}`),

  create: (data: NewsCreate) =>
    client.post<NewsItem>('/api/admin/news', data),

  update: (id: number, data: Partial<NewsCreate>) =>
    client.patch<NewsItem>(`/api/admin/news/${id}`, data),

  delete: (id: number) =>
    client.delete(`/api/admin/news/${id}`),

  /** Загрузка картинки (обложка или фото в тексте) → { url } */
  uploadImage: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return client.post<{ url: string }>('/api/admin/news/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
